import { Store } from 'core';

const { REACT_APP__API_BASE_URL } = process.env;

export default Store.initStore({
  baseURL: REACT_APP__API_BASE_URL,
});

const AuthSelectors = Store.APIAuth.selectors;
const AuthActions = Store.APIAuth.actions;
const UsersSelectors = Store.USERSList.selectors;
const UsersActions = Store.USERSList.actions;
const UserInfoSelectors = Store.UserInfo.selectors;
const UserSelectors = Store.User.selectors;
const UserActions = Store.User.actions;
const UserInfoToModifyActions = Store.UserInfoToModify.actions;
const UserInfoToModifySelectors = Store.UserInfoToModify.selectors;
const ResetPasswordActions = Store.ResetPassword.actions;
const ResetPasswordSelectors = Store.ResetPassword.selectors;
const circulationsActions = Store.Circulations.actions;
const circulationsSelectors = Store.Circulations.selectors;
const StationsSelectors = Store.Stations.selectors;
const StationsActions = Store.Stations.actions;
const stationsServedActions = Store.StationsServed.actions;
const stationsServedSelectors = Store.StationsServed.selectors;
const reasonsActions = Store.Reasons.actions;
const reasonsSelectors = Store.Reasons.selectors;
const productCodesActions = Store.ProductCodes.actions;
const productCodesSelectors = Store.ProductCodes.selectors;
const helpInfosActions = Store.HelpInfos.actions;
const helpInfosSelectors = Store.HelpInfos.selectors;
const compensationSentencesActions = Store.CompensationSentences.actions;
const compensationSentencesSelectors = Store.CompensationSentences.selectors;
const compensationSentenceActions = Store.CompensationSentence.actions;
const compensationSentenceSelectors = Store.CompensationSentence.selectors;
const helpInfoActions = Store.HelpInfo.actions;
const helpInfoSelectors = Store.HelpInfo.selectors;
const reasonActions = Store.Reason.actions;
const reasonSelectors = Store.Reason.selectors;
const productCodeActions = Store.ProductCode.actions;
const productCodeSelectors = Store.ProductCode.selectors;
const SendStatutesActions = Store.SendStatus.actions;
// Communication --------------------------------------------------------------------------
const stationsTemplatesPreviewActions = Store.StationsTemplatesPreview.actions;
const stationsTemplatesPreviewSelectors = Store.StationsTemplatesPreview.selectors;
const historicCommunicationActions = Store.HistoricCommunication.actions;
const historicCommunicationSelectors = Store.HistoricCommunication.selectors;
const historicPendingCommunicationActions = Store.HistoricPendingCommunication.actions;
const historicPendingCommunicationSelectors = Store.HistoricPendingCommunication.selectors;
const servicesPassengersConcernedByCommunicationActions = Store.ServicesPassengersConcernedByCommunication.actions;
const servicesPassengersConcernedByCommunicationSelectors = Store.ServicesPassengersConcernedByCommunication.selectors;
const LatestCommunicationActions = Store.LatestCommunication.actions;
const LatestCommunicationSelectors = Store.LatestCommunication.selectors;
const SendCommunicationActions = Store.SendCommunication.actions;
const SendCommunicationSelectors = Store.SendCommunication.selectors;
// ------------------------------------------------------------------------------------------
const customersListSelectors = Store.CustomersList.selectors;
const customersListActions = Store.CustomersList.actions;
const apiVersionActions = Store.ApiVersion.actions;
const apiVersionSelectors = Store.ApiVersion.selectors;
const SituationsActions = Store.Situations.actions;
const SituationsSelectors = Store.Situations.selectors;
const SituationsCommunicationsActions = Store.SituationsCommunications.actions;
const SituationsCommunicationsSelectors = Store.SituationsCommunications.selectors;
const SituationsCategoryActions = Store.SituationsCategory.actions;
const SituationsCategorySelectors = Store.SituationsCategory.selectors;
const SituationCategoryActions = Store.SituationCategory.actions;
const SituationCategorySelectors = Store.SituationCategory.selectors;
const SituationActions = Store.Situation.actions;
const SituationSelectors = Store.Situation.selectors;
const MasksActions = Store.Masks.actions;
const MasksSelectors = Store.Masks.selectors;
const MaskActions = Store.Mask.actions;
const MaskSelectors = Store.Mask.selectors;
const MasksConfigActions = Store.MasksConfig.actions;
const MasksConfigSelectors = Store.MasksConfig.selectors;
const ProfilesActions = Store.profiles.actions;
const ProfilesSelectors = Store.profiles.selectors;
const GroupsActions = Store.groups.actions;
const GroupsSelectors = Store.groups.selectors;
const OtherSelectionActions = Store.OtherSelection.actions;
const OtherSelectionSelectors = Store.OtherSelection.selectors;
const TypologyActions = Store.Typology.actions;
const TypologySelectors = Store.Typology.selectors;
const MessagesMasksActions = Store.MessagesMasks.actions;
const MessagesMasksSelectors = Store.MessagesMasks.selectors;
const ProfilActions = Store.Profil.actions;
const ProfilSelectors = Store.Profil.selectors;
const SectionsActions = Store.Sections.actions;
const SectionsSelectors = Store.Sections.selectors;
const ServiceTypesActions = Store.ServiceTypes.actions;
const ServiceTypesSelectors = Store.ServiceTypes.selectors;
const TranslationLanguagesActions = Store.TranslationLanguages.actions;
const TranslationLanguagesSelectors = Store.TranslationLanguages.selectors;

// Clear State Slice
const ClearStateSliceActions = Store.ClearStateSlice.actions;

export {
  AuthSelectors,
  AuthActions,
  UsersActions,
  UsersSelectors,
  UserInfoSelectors,
  UserActions,
  UserSelectors,
  UserInfoToModifyActions,
  UserInfoToModifySelectors,
  ResetPasswordActions,
  ResetPasswordSelectors,
  circulationsActions,
  circulationsSelectors,
  StationsActions,
  StationsSelectors,
  stationsServedActions,
  stationsServedSelectors,
  reasonsActions,
  reasonsSelectors,
  productCodesActions,
  productCodesSelectors,
  helpInfosActions,
  helpInfosSelectors,
  compensationSentencesActions,
  compensationSentencesSelectors,
  compensationSentenceActions,
  compensationSentenceSelectors,
  helpInfoActions,
  helpInfoSelectors,
  reasonActions,
  reasonSelectors,
  productCodeActions,
  productCodeSelectors,
  SendStatutesActions,
  // Communication ----------------------
  SendCommunicationActions,
  SendCommunicationSelectors,
  stationsTemplatesPreviewActions,
  stationsTemplatesPreviewSelectors,
  historicCommunicationActions,
  historicCommunicationSelectors,
  historicPendingCommunicationActions,
  historicPendingCommunicationSelectors,
  LatestCommunicationActions,
  LatestCommunicationSelectors,
  servicesPassengersConcernedByCommunicationActions,
  servicesPassengersConcernedByCommunicationSelectors,
  // --------------------------------------
  customersListSelectors,
  customersListActions,
  apiVersionActions,
  apiVersionSelectors,
  SituationsSelectors,
  SituationsActions,
  SituationsCommunicationsSelectors,
  SituationsCommunicationsActions,
  SituationsCategorySelectors,
  SituationsCategoryActions,
  SituationCategoryActions,
  SituationCategorySelectors,
  SituationActions,
  SituationSelectors,
  MasksSelectors,
  MasksActions,
  MaskActions,
  MaskSelectors,
  MasksConfigActions,
  MasksConfigSelectors,
  ProfilesActions,
  ProfilesSelectors,
  GroupsActions,
  GroupsSelectors,
  OtherSelectionActions,
  OtherSelectionSelectors,
  TypologyActions,
  TypologySelectors,
  MessagesMasksActions,
  MessagesMasksSelectors,
  ProfilActions,
  ProfilSelectors,
  SectionsActions,
  SectionsSelectors,
  ServiceTypesActions,
  ServiceTypesSelectors,
  TranslationLanguagesActions,
  TranslationLanguagesSelectors,

  // Clear State Slice
  ClearStateSliceActions,
};
